import { Tabs } from '../../../modules/tabs';
import { Accordion } from '../../../modules/accordion';
import { customAmountInput, invalidAmountError } from './donation-amounts';

interface MembershipType {
    name: string,
    price: {
        minimum: number,
        maximum: number
    }
}

const minimumAttribute = 'data-minimum';
const maximumAttribute = 'data-maximum';
const recommendedAttribute = 'data-recommended';
const nameAttribute = 'data-membership-level';
const typeDisplayAttribute = 'data-membership-type-display';

let tabs: Tabs[] = [], accordions: Accordion[] = [], membershipTypes: MembershipType[] = [];
const membershipTypeHiddenInput = document.querySelector('#Membership_type') as HTMLInputElement;
const typeDisplay = document.querySelector(`[${typeDisplayAttribute}]`) as HTMLElement;
const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-membership-tabs-container]')) as HTMLElement[];
const accordionEls = [].slice.call(document.querySelectorAll('[data-membership-accordion-list]'));
const membershipSelectButtons = [].slice.call(document.querySelectorAll('[data-membership-level]')) as HTMLButtonElement[];
const outOfMembershipRangeError = document.querySelector('[data-amount-range-error]') as HTMLElement;

const levelFormatting = (levelName: string) => {
    return `<p class="h3-style bold">${levelName}</p>`;
}

// Initialize any tabs
tabEls.forEach(tabEl => {
    tabs.push(
        new Tabs({
            container: tabEl
        })
    );
});

// Initialize any accordions
accordionEls.forEach(accordionEl => {
    const oneOpen = accordionEl.getAttribute('data-one-open-at-a-time');
    accordions.push(
        new Accordion({
            container: accordionEl,
            oneOpenAtATime: oneOpen === 'True'
        })
    );
});

// Read membership level information
membershipSelectButtons.forEach(button => {
    const minimum = button.getAttribute(minimumAttribute);
    const maximum = button.getAttribute(maximumAttribute);
    const recommended = button.getAttribute(recommendedAttribute);
    const name = button.getAttribute(nameAttribute);

    // Parse and make sure the numbers make sense
    const resolvedMinimum = minimum ? parseFloat(minimum) : 1;
    const resolvedMaximum = maximum ? parseFloat(maximum) : Infinity;
    let resolvedRecommended = recommended ? parseFloat(recommended) : resolvedMaximum;

    // If the recommended amount is not in between the minimum and maximum, fall back to the maximum
    resolvedRecommended = (resolvedMaximum >= resolvedRecommended && resolvedRecommended >= resolvedMinimum) ? resolvedRecommended : resolvedMaximum;

    membershipTypes.push({
        name: name,
        price: {
            minimum: resolvedMinimum,
            maximum: resolvedMaximum
        }
    });

    button.addEventListener('click', () => {
        membershipTypeHiddenInput.value = name;
        customAmountInput.value = `${resolvedRecommended}`;
        typeDisplay.innerHTML = levelFormatting(name);
        typeDisplay.removeAttribute('hidden');
        outOfMembershipRangeError.setAttribute('hidden', '');
        invalidAmountError.setAttribute('hidden', '');
    });
});

export const displayCurrentLevel = (currentValue: number) => {
    if (membershipTypes.length > 0) {
        const matchingLevels = membershipTypes.filter(type => {
            return type.price.minimum <= currentValue && currentValue <= type.price.maximum;
        });
        if (matchingLevels.length > 0) {
            outOfMembershipRangeError.setAttribute('hidden', '');
            typeDisplay.innerHTML = levelFormatting(matchingLevels[0].name);
            typeDisplay.removeAttribute('hidden');
        }
        else {
            outOfMembershipRangeError.removeAttribute('hidden');
            typeDisplay.innerHTML = '';
            typeDisplay.setAttribute('hidden', '');
        }
    }
}